import React, { useContext } from 'react';
import { setItem } from '../../../../helpers/webStorage';
import GridToggler from './gridToggler';
import { ListerContext } from '../../listerContext';
import { MessagePropertiesContext } from '../../../../contexts/messageProperties';
import { ListerActionTypes } from '../../listerReducer';
import { ListerStorageStateKey } from '../../../../types';

function GridTogglerContainer(): React.ReactElement {
  const [formattedMessage] = useContext(MessagePropertiesContext);
  const [{ isBiggerImagesSelected, isListerDisabled }, dispatch] = useContext(ListerContext);

  const gridTogglerHandler = (): void => {
    dispatch({
      type: ListerActionTypes.SET_IS_BIGGER_IMAGES_DISPLAYED,
      isBiggerImagesSelected: !isBiggerImagesSelected
    });

    setItem(ListerStorageStateKey.IS_BIGGER_IMAGES_SELECTED, !isBiggerImagesSelected);
  };

  return (
    <GridToggler
      isDisabled={isListerDisabled}
      gridTogglerHandler={gridTogglerHandler}
      isBiggerImagesSelected={isBiggerImagesSelected}
      messages={{ title: formattedMessage({ id: 'search.nav.biggerImages.title', fallback: 'View' }) }}
    />
  );
}

export default GridTogglerContainer;
